module.exports = __webpack_public_path__ + "static/assets/d8ba5c7b1fa8c4c9babce120aefd0210.svg";